import { useCallback } from "react";

import { useGroupByStore } from "../GroupByStoreProvider";
import { selectIsForecastToggleOn } from "../groupBySelectors";

export const useForecastToggle = () => {
  const isForecastToggleOn = useGroupByStore(selectIsForecastToggleOn);
  const setForecastToggle = useGroupByStore((s) => s.setForecastToggle);

  const handleToggle = useCallback(
    () => setForecastToggle(!isForecastToggleOn),
    [setForecastToggle, isForecastToggleOn]
  );

  return {
    isForecastToggleOn,
    onToggle: handleToggle
  };
};
